// @flow
import menuItems from '@lumera_configs/side_menus/diamond_education_menu.json';

import SideMenu from './SideMenu';

const DiamondEducationMenu = () => <SideMenu items={menuItems} />;

export default DiamondEducationMenu;
